export default "__VITE_ASSET__BSIJhlxK__"